import { makeStyles } from 'tss-react/mui';
import { inputStyles } from '../../styles/jss/inputs';
const useStyles = makeStyles()((theme, _params, classes) => inputStyles(theme, classes));
export default useStyles;
